/**
 * en-GB messages added by Phase 1 task W0 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w0EnGB = {
    // Site picker (top bar and menu drawer)
    'site.picker': 'Site',
    'site.switch': 'Switch site',
    'site.none': 'No sites yet',
    'site.loadFailed': 'Your sites could not be loaded.',
    // Live updates
    'live.connected': 'Live updates are on',
    'live.reconnecting': 'Live updates paused. Reconnecting.',
    // Settings cards for sites and groups
    'settingsCards.empty': 'No other settings to show here.',
    'settingsCards.loadFailed': 'These settings could not be loaded.',
    // Shared widgets
    'widget.sort.handle': 'Drag to reorder {name}',
    'widget.sort.moveUp': 'Move {name} up',
    'widget.sort.moveDown': 'Move {name} down',
    'widget.sort.moved': '{name} moved to position {position} of {total}',
    'widget.file.drop': 'Drop a file here, or choose one',
    'widget.file.choose': 'Choose file',
    'widget.file.replace': 'Choose a different file',
    'widget.file.remove': 'Remove file',
    'widget.file.wrongType': 'That type of file is not allowed.',
    'widget.file.tooBig': 'That file is too big. The limit is {limit}.',
    'widget.file.unreadable': 'That image could not be read.',
    'widget.file.selected': 'Selected: {name}',
    'widget.signature.label': 'Signature',
    'widget.signature.none': 'No signature',
    'widget.export.label': 'Export',
    'widget.export.csv': 'CSV file',
    'widget.export.xlsx': 'Excel file',
    'widget.export.working': 'Preparing download',
    'widget.export.failed': 'The export could not be downloaded.',
};
//# sourceMappingURL=w0.js.map